exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expiry-soon {\n  color: red; }\n\n.gold .codeColumn {\n  background-color: #FFBA80; }\n\n.green .codeColumn {\n  background-color: #B2F699; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/overview/visa-expiry/visa-expiry.component.scss
// module id = ../../../../../src/app/hrms/overview/visa-expiry/visa-expiry.component.scss
// module chunks = main